import { render, staticRenderFns } from "./OrderSubstitutions.vue?vue&type=template&id=a81e7480&scoped=true"
import script from "./OrderSubstitutions.vue?vue&type=script&lang=js"
export * from "./OrderSubstitutions.vue?vue&type=script&lang=js"
import style0 from "./OrderSubstitutions.vue?vue&type=style&index=0&id=a81e7480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e7480",
  null
  
)

export default component.exports